export enum UserRole {
    User = "user",
    Admin = "admin",
    UserAdmin = "useradmin",
    SuperAdmin = "superadmin",
    BusinessPartner = "businesspartner"
}
